import { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useVideoSurveyInventory } from "../../../../../hooks/useVideoSurveyInventory";
import { DifferentLocation } from "../../../../../models/location";
import { CustomerLocations, RoomJob } from "../../../../../models/sales";
import { User } from "../../../../../models/user";
import { useAction as useInventoryAction } from "../../../../Generic/QuotedInventory/useActions";

export enum LocationType {
  ORIGIN = "origin",
  DESTINATION = "destination",
}

export type LocationOption = {
  label: string;
  value: LocationType.ORIGIN | LocationType.DESTINATION;
};

export const useTabComponentActions = () => {
  const { t: translate } = useTranslation();
  const { inventory, setInventory, job, updateEnabled, setUpdateEnabled } =
    useVideoSurveyInventory();

  const _setInventory = (value: RoomJob[]) => {
    if (!updateEnabled) setUpdateEnabled(true);

    setInventory(value);
  };

  const { handleAddRoom, handleAddItemToRoom, handleAddMaterialToRoom, handleUpdateRoom } =
    useInventoryAction({
      data: inventory,
      jobId: job?.id || 0,
      defaultMode: job?.mode,
      update: (value) => _setInventory(value),
    });

  const typeOfLocations: LocationOption[] = useMemo(
    () => [
      { label: translate("pickup"), value: LocationType.ORIGIN },
      { label: translate("delivery"), value: LocationType.DESTINATION },
    ],
    []
  );

  const getLongAddressFromLocation = (location?: DifferentLocation): string => {
    if (location) return location.longAddress ?? "";

    return "";
  };

  const getCustomerFromLocation = (location?: CustomerLocations): string => {
    if (location && location.customer) {
      const { name, lastName } = location.customer;

      return `${name || ""} ${lastName || ""}`;
    }

    return "";
  };

  const getUserFullName = (user?: User): string => {
    if (user) {
      const { name, lastName } = user;

      return `${name || ""} ${lastName || ""}`;
    }

    return "";
  };

  return {
    typeOfLocations,
    getLongAddressFromLocation,
    getCustomerFromLocation,
    getUserFullName,
    handleAddRoom,
    handleAddItemToRoom,
    handleAddMaterialToRoom,
    handleUpdateRoom,
  };
};
